import { Navigate } from "react-router-dom";
import { useUser } from "../context/userContext";
import { normalizeLang } from "../utils/i18n";

// Sends any inaccessible destination (the root path, or an unmatched route)
// to wherever this user actually belongs, instead of always dumping them on
// the login screen even when they're already authenticated.
export default function HomeRedirect() {
  const { isAuthenticated, loading, isOnboarded, user } = useUser();

  if (loading) return null;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (!isOnboarded) return <Navigate to={`/onboarding/${normalizeLang(user?.lang)}`} replace />;

  return <Navigate to="/transcribe" replace />;
}
